import * as z from "zod";

// Pieces of schema more than one feature of the booking domain uses; not part of `@nexxt/contracts/booking`.

/** A time of day of a showroom, `HH:mm`, in the time zone of its location. */
export const timeOfDay = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/);
